import { Moment } from "moment";
import { StudentRoom } from "./student-room";

export class StudentPost {

    constructor(
        public firstName: string,
        public lastName: string,
        public languageId: number,
        public genderId: number,
        public studentRoom: StudentRoom | null,
        public allergies: string,
        public birthDate: Moment | null
    ){}
}
